import { render, staticRenderFns } from "./EditCategories.vue?vue&type=template&id=2d48e71c&scoped=true"
import script from "./EditCategories.vue?vue&type=script&lang=js"
export * from "./EditCategories.vue?vue&type=script&lang=js"
import style0 from "./EditCategories.vue?vue&type=style&index=0&id=2d48e71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d48e71c",
  null
  
)

export default component.exports